module.exports = __webpack_public_path__ + "img/Logo_Flui3d.5c73027b.svg";